export default __webpack_public_path__ + "static/media/meridional-m-white.438d7dff.png";